export default __webpack_public_path__ + "static/media/samurai.da25c01f.gif";